import { render, staticRenderFns } from "./RegisteredMember.vue?vue&type=template&id=4161325a&scoped=true&"
import script from "./RegisteredMember.vue?vue&type=script&lang=js&"
export * from "./RegisteredMember.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredMember.vue?vue&type=style&index=0&id=4161325a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161325a",
  null
  
)

export default component.exports